import { createClient } from "@supabase/supabase-js";

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL as string | undefined;
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY as string | undefined;

if (!supabaseUrl || !supabaseAnonKey) {
  // Fail loudly at startup rather than with a confusing runtime error deep
  // inside a fetch call the first time someone opens the map.
  throw new Error(
    "VITE_SUPABASE_URL / VITE_SUPABASE_ANON_KEY manjkata. Preveri .env (glej .env.example).",
  );
}

export const supabase = createClient(supabaseUrl, supabaseAnonKey, {
  auth: { persistSession: false },
});

/** Base URL for calling this project's Edge Functions directly via fetch. */
export const functionsUrl = `${supabaseUrl.replace(/\/$/, "")}/functions/v1`;

export async function callEdgeFunction<TResponse>(
  name: string,
  body: unknown,
): Promise<TResponse> {
  const res = await fetch(`${functionsUrl}/${name}`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "Authorization": `Bearer ${supabaseAnonKey}`,
      "apikey": supabaseAnonKey as string,
    },
    body: JSON.stringify(body),
  });

  const data = await res.json().catch(() => null);
  if (!res.ok) {
    const message = (data && typeof data === "object" && "error" in data && String(data.error)) || res.statusText;
    throw new Error(message);
  }
  return data as TResponse;
}
